import { c as _c } from "react/compiler-runtime";
import { BriefcaseClockIcon } from '@navikt/aksel-icons';
import { ExpansionCard, HStack } from '@navikt/ds-react';
import Knappenavn from './Knappenavn';
import styles from './Seksjon.module.css';
import { store } from '@/app/_components/store/store';
import SeksjonsListe, { SeksjonsFelt } from '@/components/seksjons-liste';
import SortedTable from '@/components/sorted-table';
import { PermisjonOgPermittering } from 'types/arbeidsforhold';
import { formatDatePeriode } from 'utils/formatting/dato';
interface Props {
  data: Array<PermisjonOgPermittering> | null;
}
const PermisjonPermittering = props => {
  const $ = _c(35);
  const {
    tekst
  } = store.useReducerState();
  let t0;
  if ($[0] !== tekst.hjelpetekst.permisjon.periode || $[1] !== tekst.permisjon.periode) {
    t0 = {
      label: tekst.permisjon.periode,
      hjelpetekst: tekst.hjelpetekst.permisjon.periode,
      getValue: _temp,
      sortValue: _temp2
    };
    $[0] = tekst.hjelpetekst.permisjon.periode;
    $[1] = tekst.permisjon.periode;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== tekst.hjelpetekst.permisjon.type || $[4] !== tekst.permisjon.type) {
    t1 = {
      label: tekst.permisjon.type,
      hjelpetekst: tekst.hjelpetekst.permisjon.type,
      getValue: _temp3
    };
    $[3] = tekst.hjelpetekst.permisjon.type;
    $[4] = tekst.permisjon.type;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== tekst.hjelpetekst.permisjon.prosent || $[7] !== tekst.permisjon.prosent) {
    t2 = {
      label: tekst.permisjon.prosent,
      hjelpetekst: tekst.hjelpetekst.permisjon.prosent,
      getValue: _temp4
    };
    $[6] = tekst.hjelpetekst.permisjon.prosent;
    $[7] = tekst.permisjon.prosent;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== tekst.hjelpetekst.permisjon.id || $[10] !== tekst.permisjon.id) {
    t3 = {
      label: tekst.permisjon.id,
      hjelpetekst: tekst.hjelpetekst.permisjon.id,
      getValue: _temp5,
      sortable: false
    };
    $[9] = tekst.hjelpetekst.permisjon.id;
    $[10] = tekst.permisjon.id;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== t0 || $[13] !== t1 || $[14] !== t2 || $[15] !== t3) {
    t4 = [t0, t1, t2, t3];
    $[12] = t0;
    $[13] = t1;
    $[14] = t2;
    $[15] = t3;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  const felter = t4;
  let t5;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div><BriefcaseClockIcon aria-hidden={true} className={styles.ikon} /></div>;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  let t6;
  if ($[18] !== tekst.permisjon.permisjon) {
    t6 = <ExpansionCard.Header><HStack wrap={false} gap="space-16" align="center" className={styles.header}>{t5}<div><ExpansionCard.Title>{tekst.permisjon.permisjon}</ExpansionCard.Title></div></HStack></ExpansionCard.Header>;
    $[18] = tekst.permisjon.permisjon;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  let t7;
  if ($[20] !== t6 || $[21] !== tekst.permisjon.permisjon) {
    t7 = <Knappenavn navn={tekst.permisjon.permisjon}>{t6}</Knappenavn>;
    $[20] = t6;
    $[21] = tekst.permisjon.permisjon;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  let t8;
  if ($[23] !== felter || $[24] !== props.data || $[25] !== tekst.filter || $[26] !== tekst.permisjon.ingenTreff || $[27] !== tekst.permisjon.periode) {
    t8 = props.data == null ? tekst.filter.ikkeValgt : props.data?.length === 0 ? tekst.permisjon.ingenTreff : <><div className={styles.kunBred}><SortedTable simple={true} initialData={props.data || []} itemsToShow={3} sortable={false} orderBy={tekst.permisjon.periode} direction="descending" fields={felter} /></div><div className={styles.kunSmal}><SeksjonsListe data={props.data || []} felter={felter} noekkel={0} itemsToShow={3} /></div></>;
    $[23] = felter;
    $[24] = props.data;
    $[25] = tekst.filter;
    $[26] = tekst.permisjon.ingenTreff;
    $[27] = tekst.permisjon.periode;
    $[28] = t8;
  } else {
    t8 = $[28];
  }
  let t9;
  if ($[29] !== t8) {
    t9 = <ExpansionCard.Content className={styles.innhold}>{t8}</ExpansionCard.Content>;
    $[29] = t8;
    $[30] = t9;
  } else {
    t9 = $[30];
  }
  let t10;
  if ($[31] !== t7 || $[32] !== t9 || $[33] !== tekst.permisjon.permisjon) {
    t10 = <ExpansionCard aria-label={tekst.permisjon.permisjon} defaultOpen={true} className={styles.kort}>{t7}{t9}</ExpansionCard>;
    $[31] = t7;
    $[32] = t9;
    $[33] = tekst.permisjon.permisjon;
    $[34] = t10;
  } else {
    t10 = $[34];
  }
  return t10;
};
export default PermisjonPermittering;
function _temp(data) {
  return formatDatePeriode(data.startdato, data.sluttdato);
}
function _temp2(data_0) {
  return data_0.startdato;
}
function _temp3(data_1) {
  return data_1.type?.beskrivelse;
}
function _temp4(data_2) {
  return `${data_2.prosent} %`;
}
function _temp5(data_3) {
  return data_3.id;
}